module.exports = __webpack_public_path__ + "8018a41151bdfd6db1803a5636cb8120.svg";